<template>
  <div class="component-wrapper">
    <!-- <button @click="$emit('trigger-nav-link', 'main')">exit</button> -->
    <!-- <button @click="confirmNull()">I Don't Know</button> -->
    <h4 
      v-for="(t,i) in texts" 
      :key="i" 
      class="newfont"
      :style="{ fontSize:fontsize }" 
      style="text-align:center">{{ t }}</h4>
    <div class="flex">
      <div v-for="(s,i) in selection" :key="i" class="input-wrapper">
        <button 
          :class="{ active: selected.indexOf(s) >= 0 }"
          class="select-std newfont"
          @click="selectValue(s)">{{s}}</button>
      </div>
      <span class="red" v-if="valueError">Required: {{inputError}}</span>
    </div>
    <br />
    <div class="nav-flex">
      <button class="button-std newfont" @click="backstep"><span class="material-icons">chevron_left</span>Back</button>
      <button class="button-std" @click="nextstep">Next<span class="material-icons">chevron_right</span></button>
    </div>
  </div>
</template>

<script>

const verify = {
  'minLength':function(obj,value){
    if(obj.minLength >= value.length){
      return `value is not above minimum length ${obj.minLength}`
    }
    return true;
  }
}
const verifier = (arr, value) => {
  return arr.reduce((acc,cv) => {
    let key = Object.keys(cv)[0]
    if(verify[key] !== undefined){
      acc = verify[key](cv,value)
    }
    return acc;
  },true)
}
export default {
  name:"selectionInput",
  components:{

  },
  props:{
    verify: {
      type: Array,
      default: function(){
        return []
      }
    },
    showNext: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showExit: {
      type: Boolean,
      default: false
    },
    fontsize: {
      default:"1em",
      type:String
    },
    backto: {
      type:Number
    },
    goto: {
      type:Number
    },
    for: {
      type:String,
      default:"None"
    },
    texts: {
      type:Array,
      default: function(){
        return []
      }
    },
    selection:{
      type:Array,
      default: function(){
        return []
      }
    },
    minSelection:{
      type:Number,
      default:0
    },
    maxSelection:{
      type:Number,
      default:1
    },
    event_order:{
      type:Number
    },
    currentFrame:{
      type:Number
    }
  },
  data(){
    return {
      valueError:false,
      inputError:"",
      inputValue:"",
      errors: [],
      showConfirmPrompt: false,
      confirmMessage:"",
      selected:[]
    }
  },
  computed:{
    newpin: function(){
      return this.char1+this.char2+this.char3+this.char4
    }
  },
  watch: {
    currentFrame:function(){
      if(this.currentFrame === this.event_order){
        this.setHeight()
      }
    }
  },
  methods:{
    setHeight(){
      console.log('setting height');
      console.log(this.currentFrame);
      let f = document.getElementById(this.currentFrame)
      console.log(f.style.height);
      f.style.height = `${f.offsetHeight+400}px`
      console.log(f.style.height);
    },
    nextstep(){
      //localStorage.setItem('pin', JSON.stringify(this.newpin))
      //console.log(this.verify);
      let out = verifier(this.verify,this.selected)
      let lenOk = this.minSelection <= this.selected.length;
      if(out === true && lenOk === true){
        this.$emit('nextstep', {for:this.for, stepVal:this.goto, val:this.selected.join(", ")})
      } else {
        if(lenOk !== true){
          out = `did not select minimum amount ${this.minSelection}`;
        }
        this.inputerror(out)
      }
    },
    inputerror(out){
      this.valueError = true;
      this.inputError = out
      setTimeout(() => {
        this.valueError = false;
        this.inputError = ""
      },9000)
    },
    backstep(){
      this.$emit('backstep', {for:this.for, stepVal:this.backto})
    },
    selectValue(name){
      let idx = this.selected.indexOf(name);
      if(idx === -1){
        //console.log(this.maxSelection);
        //console.log(this.selected.length);
        //console.log(this.maxSelection);
        //console.log(this.maxSelection > this.selected.length+1);

        if(this.maxSelection > this.selected.length){
          this.selected.push(name)
        } else {
          //console.log('input error send')
          this.inputerror(`maximum items selected ${this.maxSelection}, unselect a currently selected item to add a different item`)
        }
      } else {
        this.selected.splice(idx,1)
      }
    }
  },
  beforeCreate(){
    // //console.log('nothing gets created before me')
  },
  created(){

  },
  beforeMount(){

  },
  mounted(){
    document.appObserver.register('resetSelectInput', () => {
      this.selected = []
    });
  },
  beforeUpdate(){

  },
  updated(){

  },
  beforeDestroy(){

  },
  destroyed(){

  }
}

</script>

<style scoped>
.active {
  background-color:navy;
  color:white;
}

.flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.nav-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items:center;
}
.box {
    box-sizing: border-box;
    cursor: pointer;
}
.input-wrapper {
  margin: 10px 0.5em;
}
.red {
  color:red;
}

.button-std {
  background-color:#325DFF;
  color:#fff;
  font-weight:600;
  padding: 10px 20px;
  border-radius:9px;
  display:flex;
  align-items:center;
  cursor:pointer;
}
.select-std {
  border: 6px solid #00daa1;
  color: #fff;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 9px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  color: #0fb5aa;
  font-size: 2em;
}
.newfont {
  font-family:'Varela Round';
}
</style>
